import { useQuery } from '@tanstack/react-query';

import type { QueryFunction } from '@frontend/api';
import { useRequest } from '@frontend/api';

import type { TeamAssignmentsQueryKeyType } from './getTeamAssignmentsQueryKey';
import { getTeamAssignmentsQueryKey } from './getTeamAssignmentsQueryKey';
import type {
  TeamAssignmentsQueryParams,
  TeamAssignmentsResponse,
} from './types';

export const useGetTeamAssignments: QueryFunction<
  TeamAssignmentsResponse,
  [],
  TeamAssignmentsQueryKeyType,
  TeamAssignmentsQueryParams
> = ({ requestOptions, queryOptions, query } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    keepPreviousData: true,
    ...queryOptions,
    queryKey: getTeamAssignmentsQueryKey(query),
    queryFn: ({ signal }) =>
      request<TeamAssignmentsResponse>('/quotes/team_assignments', {
        query,
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
